var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.854,
    height: 78.242,
    viewBox: "0 0 65.854 78.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9782",
    "data-name": "Group 9782",
    transform: "translate(-9 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10274",
    "data-name": "Path 10274",
    d: "M54.005,40.4H28.438A19.465,19.465,0,0,0,9,59.854v7.959a1.4,1.4,0,0,0,1.4,1.4H72.2a1.4,1.4,0,0,0,1.4-1.4V59.854A19.549,19.549,0,0,0,54.005,40.4Zm-5.935,2.653a6.982,6.982,0,0,1-13.7,0ZM11.653,66.487H70.79l-.056-6.633A16.757,16.757,0,0,0,53.977,43.1h-3.24a9.621,9.621,0,0,1-19.074,0H28.41A16.757,16.757,0,0,0,11.653,59.854Z",
    transform: "translate(0 14.033)",
    fill: "#030135",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10275",
    "data-name": "Path 10275",
    d: "M35.964,48.373A13.7,13.7,0,0,0,49.648,34.688V28.516a13.684,13.684,0,1,0-27.369,0v6.172A13.684,13.684,0,0,0,35.964,48.373Zm0-30.888C40.368,17.489,30.988,17.493,35.964,17.485ZM24.863,34.7a11.031,11.031,0,1,0,22.063,0V28.53C46.947,28.121,25.228,29.181,24.863,34.7Z",
    transform: "translate(5.264 3.897)",
    fill: "#030135",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10278",
    "data-name": "Path 10278",
    d: "M59.3,13.792a9.649,9.649,0,0,1-12.051,1.271,1.4,1.4,0,0,0-.182-2.793H43.637a1.4,1.4,0,0,0-1.4,1.4V17.1a1.4,1.4,0,0,0,2.793,0v-.307a12.372,12.372,0,0,0,16.2-1.117A1.348,1.348,0,1,0,59.3,13.792Z",
    transform: "translate(13.176 2.881)",
    fill: "#030135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10279",
    "data-name": "Path 10279",
    d: "M60.266,5.784a1.4,1.4,0,0,0-1.4,1.4V7.5A12.386,12.386,0,0,0,42.658,8.618a1.383,1.383,0,0,0,1.969,1.941A9.649,9.649,0,0,1,56.65,9.247a1.4,1.4,0,0,0,.182,2.793h3.435a1.4,1.4,0,0,0,1.4-1.4V7.152A1.4,1.4,0,0,0,60.266,5.784Z",
    transform: "translate(13.191 0)",
    fill: "#030135"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon1);
export default __webpack_public_path__ + "static/media/box-icon-1.e47ea4140a1ba834f601c2474ee9efc6.svg";
export { ForwardRef as ReactComponent };